/**
 * DOMHelpers
 * Type-safe DOM manipulation utilities
 */
export class DOMHelpers {
    /**
     * Create element with attributes and children
     * @param {string} tag
     * @param {Object} attributes
     * @param {Array<HTMLElement|string>} children
     * @returns {HTMLElement}
     */
    static createElement(tag, attributes = {}, children = []) {
        const element = document.createElement(tag);

        // Set attributes
        Object.entries(attributes).forEach(([key, value]) => {
            if (key === 'className') {
                element.className = value;
            } else if (key === 'dataset') {
                Object.entries(value).forEach(([dataKey, dataValue]) => {
                    element.dataset[dataKey] = dataValue;
                });
            } else if (key.startsWith('on')) {
                // Event listener
                const eventName = key.substring(2).toLowerCase();
                element.addEventListener(eventName, value);
            } else {
                element.setAttribute(key, value);
            }
        });

        // Append children
        children.forEach(child => {
            if (typeof child === 'string') {
                element.appendChild(document.createTextNode(child));
            } else if (child instanceof HTMLElement) {
                element.appendChild(child);
            }
        });

        return element;
    }

    /**
     * Remove element safely
     */
    static remove(element) {
        if (element && element.parentNode) {
            element.parentNode.removeChild(element);
        }
    }

    /**
     * Toggle element visibility
     */
    static toggle(element, show) {
        if (show === undefined) {
            element.style.display = element.style.display === 'none' ? '' : 'none';
        } else {
            element.style.display = show ? '' : 'none';
        }
    }

    /**
     * Scroll to bottom of container
     */
    static scrollToBottom(container) {
        container.scrollTop = container.scrollHeight;
    }
}
